"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageSuccessModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var reactstrap_1 = require("reactstrap");
var journey_services_1 = require("@ferry/journey-services");
var portal_core_1 = require("@ferry/portal-core");
var StorageSuccessModal = /** @class */ (function (_super) {
    __extends(StorageSuccessModal, _super);
    function StorageSuccessModal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isOpen: true
        };
        _this.close = _this.close.bind(_this);
        return _this;
    }
    StorageSuccessModal.prototype.render = function () {
        var closeBtn = (0, jsx_runtime_1.jsx)("button", { className: "btn-close", onClick: this.close });
        return ((0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { className: "success-modal ".concat(this.props.cssClass ? this.props.cssClass : ""), isOpen: this.state.isOpen, children: [(0, jsx_runtime_1.jsx)(reactstrap_1.ModalHeader, { close: closeBtn, children: (0, jsx_runtime_1.jsxs)("div", { className: "d-flex success-icon-container", children: [(0, jsx_runtime_1.jsx)("img", { className: "d-block mb-3 success-icon", src: "/".concat(portal_core_1.resourcesHelper.THEME_PATH, "/img/check-mark-big-light-green.svg"), alt: "Process complete", "aria-label": "Process complete picture", tabIndex: 0, width: 32, height: 32 }), (0, jsx_runtime_1.jsx)("h1", { className: "font-weight-700", children: "All done" })] }) }), (0, jsx_runtime_1.jsxs)(reactstrap_1.ModalBody, { className: "pt-0", children: [(0, jsx_runtime_1.jsx)("span", { className: "success-title", children: this.props.title }), (0, jsx_runtime_1.jsx)("div", { children: this.props.explanationWording })] }), (0, jsx_runtime_1.jsx)("div", { className: "empty-column" }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalFooter, { children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary btn-blue-dashboard btn-modal", onClick: this.close, children: "Ok, I understand" }) })] }));
    };
    StorageSuccessModal.prototype.close = function () {
        window.sessionStorage.removeItem("showPopup");
        var referrerJourney = window.sessionStorage.getItem("referrerJourney");
        var mtaSuccessPopupMessage = window.sessionStorage.getItem("mtaSuccessMessageText");
        if (referrerJourney && referrerJourney === journey_services_1.INTERACTION_PROCESS_MTA && mtaSuccessPopupMessage) {
            window.sessionStorage.removeItem("mtaSuccessMessageText");
        }
        this.setState({
            isOpen: false
        });
        if (this.props.onClose) {
            this.props.onClose();
        }
    };
    return StorageSuccessModal;
}(React.Component));
exports.StorageSuccessModal = StorageSuccessModal;
//# sourceMappingURL=StorageSuccessModal.js.map